import { useEffect } from "react"
import moment from "moment"
import type { FormInstance } from "antd/lib/form"
import useQueryParams from "./useQueryParams"

// tog'a #257 (2026-10-20): filtr oynasi qayta ochilganda URL dagi joriy filtrlar formaga yuklanmasdi — maydonlar `defaultValue`
// bilan faqat KO'RINARDI, forma qiymati esa bo'sh edi: hech narsani o'zgartirmay OK bosilsa sklad/kontragent/artikul jimgina
// o'chib ketardi, artikul/shtrix-kod umuman ko'rinmasdi. Endi oyna ochilganda URL → forma (id va is* — son, sana — interval).
const NUM = /Id$|^is[A-Z]/

export default function useFilterFormSync(
  form: FormInstance,
  matcher: string,
  dateNames: { begin: string; end: string } = { begin: "begin", end: "end" },
  intervalField = "interval",
) {
  const query = useQueryParams()
  const open = query.has(matcher)
  useEffect(() => {
    if (!open) return
    const v: Record<string, any> = {}
    Object.entries(query.values).forEach(([k, raw]) => {
      if (k === matcher || typeof raw !== "string" || raw === "") return
      v[k] = NUM.test(k) && /^-?\d+$/.test(raw) ? Number(raw) : raw
    })
    const b = query.values[dateNames.begin], e = query.values[dateNames.end]
    if (typeof b === "string" && b && typeof e === "string" && e) v[intervalField] = [moment(b), moment(e)]
    form.resetFields()
    form.setFieldsValue(v)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])
}
